import { FiAlertTriangle, FiClock, FiHeart, FiInfo, FiPower, FiShield, FiTool, FiUnlock } from 'react-icons/fi'
import { commonIcons } from './icons'

const ALARM_EVENT_ICONS = {
  activation: FiPower,
  fire: FiAlertTriangle,
  medical: FiHeart,
  openclose: FiUnlock,
  panic: FiShield,
  timertest: FiClock,
  trouble: FiTool,
  info: FiInfo
}

export enum MyMonitoringEventIcon {
  activation = 'activation',
  fire = 'fire',
  medical = 'medical',
  openclose = 'openclose',
  panic = 'panic',
  timertest = 'timertest',
  trouble = 'trouble',
  info = 'info'
}

export const myMonitoringEventIconBuilder = (eventType: string, icon?: string) => {
  // if (isUserEvent && profileImage) {
  //   return (
  //     <ImageComponent
  //       src={profileImage}
  //       alt='User profile image'
  //       imageClasses='w-[26px] h-[26px] rounded-full border-[1px] border-secondary-content/30'
  //     />
  //   )
  // }

  if (icon === MyMonitoringEventIcon.activation) {
    return <commonIcons.mmEventActivation className='text-error text-[1.6rem]' />
  }
  if (icon === MyMonitoringEventIcon.medical) {
    return <commonIcons.mmEventMedical className='text-error text-[1.6rem]' />
  }
  if (icon === MyMonitoringEventIcon.openclose) {
    if (eventType?.toLowerCase() === 'r') {
      return <commonIcons.mmEventClose className='text-error text-[1.3rem]' />
    } else {
      return <commonIcons.mmEventOpen className='text-success text-[1.3rem]' />
    }
  }
  if (icon === MyMonitoringEventIcon.panic) {
    return <commonIcons.mmEventPanic className='text-info text-[1.3rem]' />
  }
  if (icon === MyMonitoringEventIcon.timertest) {
    return <commonIcons.mmEventTimerTest className='text-info text-[1.3rem]' />
  }
  if (icon === MyMonitoringEventIcon.trouble) {
    return <commonIcons.mmEventTrouble className='text-error text-[1.3rem]' />
  }

  return <commonIcons.mmEventInfo className='text-info text-[1.3rem]' />
}
